/* unplugin-vue-components disabled */import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-d868e300"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line1"
}, null, -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line2"
}, null, -1));
export default /*#__PURE__*/_defineComponent({
  setup(__props) {
    const handleToOfficial = () => {
      window.open(process.env.VUE_APP_OFFICIAL_URL);
    };
    const logoIcon = ref(process.env.VUE_APP_OFFICIAL_LOGO);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
        class: "logo",
        onClick: handleToOfficial
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("img", {
        src: logoIcon.value,
        alt: ""
      }, null, 8, _hoisted_2)])]), _hoisted_3, _hoisted_4], 64);
    };
  }
});